(function(konto) {
	konto.od = {};
} (konto = window.konto));
